import { render, staticRenderFns } from "./CampaignBackground.vue?vue&type=template&id=2664ed34&"
import script from "./CampaignBackground.vue?vue&type=script&lang=js&"
export * from "./CampaignBackground.vue?vue&type=script&lang=js&"
import style0 from "./CampaignBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports